<template>
  <section class="search-results">

    <StickySectionHeader v-if="itemsLoaded" :header="productData.gallery.title" />

    <div v-if="items.length" class="container container-small" ref="stickySectionHeaderInit">
      <AccentHeader
        :header="productData.gallery.title"
        :underline="true"
        :uppercase="false"
      />
      <div class="results-wrapper">
        <ProductPreview
          v-for="(item, index) in items.slice(pageOffset, maxInitLength)"
          :key="'item-' + index"
          :item="item"
          :ref="'searchResultsItem' + item.id"
        />
      </div>
      <div class="search-results-footer">
        <nav class="pagination"
             v-if="items.length > maxInit">
          <ul>
            <li class="pagination-prev"
                v-if="page >= 2">
              <button type="button"
                      @click="loadLess"
                      :title="productData.gallery.prevPage">
                <svg height="14" width="24"><use xlink:href="#arrowBackSvg"></use></svg>
              </button>
            </li>
            <li v-for="(pageItem, index) in paginationItems"
                :key="'paginationItem-' + index"
                 class="pagination-item">
              <span v-if="pageItem === 'ellipses'">…</span>
              <button type="button"
                      v-else
                      @click="loadPage($event, pageItem)"
                      :disabled="page === pageItem">
                {{ pageItem }}
              </button>
            </li>
            <li class="pagination-next"
                v-if="items.length > maxInitLength">
              <button type="button"
                      @click="loadMore"
                      :title="productData.gallery.nextPage">
                <svg height="14" width="24"><use xlink:href="#arrowBackSvg"></use></svg>
              </button>
            </li>
          </ul>
        </nav>
        <ScrollTo :dark="true" :top="true" :where="0" speed="2500"/>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import AccentHeader from '@/components/AccentHeader.vue'
import ProductPreview from '@/components/product/ProductPreview.vue'
import ScrollTo from '@/components/ScrollTo.vue'
import StickySectionHeader from '@/components/StickySectionHeader.vue'

export default {
  name: 'productGallery',
  components: {
    AccentHeader,
    ProductPreview,
    StickySectionHeader,
    ScrollTo
  },
  data () {
    return {
      page: 1,
      pageOffset: 0,
      itemsOffset: this.maxInit,
      maxInitLength: this.maxInit,
      paginationItems: [],
      itemsLoaded: false
    }
  },
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    maxInit: {
      type: Number,
      default () {
        return 36
      }
    }
  },
  computed: {
    ...mapGetters([
      'activeCategoryName',
      'activeListItem',
      'productData'
    ])
  },
  methods: {
    loadMore (event) {
      this.page = (this.$route.query.strona ? (parseInt(this.$route.query.strona) + 1) : (parseInt(this.page) + 1))
      this.pageOffset = ((this.page - 1) * this.maxInit)
      this.itemsOffset = (this.pageOffset + this.maxInit)
      this.maxInitLength = Math.min(this.itemsOffset, this.items.length)
      this.$router.push({ 'query': Object.assign({}, this.$route.query, { 'strona': this.page }) })
      event.target.blur()
    },
    loadLess (event) {
      if (this.$route.query.strona && parseInt(this.$route.query.strona) > 1) {
        this.page = (this.$route.query.strona ? (parseInt(this.$route.query.strona) - 1) : (parseInt(this.page) - 1))
        this.pageOffset = ((this.page - 1) * this.maxInit)
        this.itemsOffset = (this.pageOffset + this.maxInit)
        this.maxInitLength = Math.min(this.itemsOffset, this.items.length)
        this.$router.push({ 'query': Object.assign({}, this.$route.query, { 'strona': this.page }) })
        event.target.blur()
      }
    },
    loadPage (event, num) {
      this.page = num
      this.$router.push({ 'query': Object.assign({}, this.$route.query, { 'strona': this.page }) })
      event.target.blur()
    },
    getCurrentPageOffset (maxItems) {
      if (this.$route.query.strona && parseInt(this.$route.query.strona) > 1) {
        this.page = parseInt(this.$route.query.strona)
        this.pageOffset = ((this.page - 1) * this.maxInit)
        this.itemsOffset = (this.pageOffset + this.maxInit)
        this.maxInitLength = Math.min(this.itemsOffset, maxItems)
      } else {
        this.pageOffset = 0
        this.itemsOffset = this.maxInit
        this.maxInitLength = this.maxInit
        this.page = 1
      }
    },
    getPaginationItems () {
      const itemsNum = Math.ceil(this.items.length / this.maxInit)
      const paged = parseInt(this.page)
      let retArr = []
      let pages = []
      this.paginationItems = []

      if (paged >= 1) {
        pages.push(paged)
      }
      if (paged >= 3) {
        pages.push(paged - 1)
        pages.push(paged - 2)
      }
      if ((paged + 2) <= itemsNum) {
        pages.push(paged + 2)
        pages.push(paged + 1)
      }
      // SORT PAGES
      pages.sort((a, b) => a - b)

      // ADD FIRST PAGE
      if (pages.indexOf(1) === -1) {
        retArr.push(1)
        // ADD ELLIPSESES IF NECESSARY
        if (pages.indexOf(2) === -1) {
          retArr.push('ellipses')
        }
      }
      // ADD PAGES
      pages.forEach((item) => {
        retArr.push(item)
      })
      // ADD LAST PAGE
      if (pages.indexOf(itemsNum) === -1) {
        // ADD ELLIPSESES IF NECESSARY
        if (pages.indexOf(itemsNum - 1) === -1) {
          retArr.push('ellipses')
        }
        retArr.push(itemsNum)
      }

      this.paginationItems = retArr

      setTimeout(() => {
        this.itemsLoaded = true
      }, 250)
    },
    scrollToActiveItem (itemsArr) {
      const currentItems = itemsArr.slice(this.pageOffset, this.maxInitLength)
      const $resultsWrapper = document.documentElement
      let $resultsActiveItem = null
      let inCurrentItems = null

      if (!this.activeListItem) return false
      inCurrentItems = currentItems.filter((item) => { return item.id === this.activeListItem }).length
      $resultsActiveItem = this.$refs['searchResultsItem' + this.activeListItem]

      if (!inCurrentItems || !$resultsWrapper || !$resultsActiveItem[0].$el) return false
      this.setScrollAnimation($resultsWrapper, $resultsActiveItem[0].$el, 600, 100)
    },
    setScrollAnimation ($container, $target, duration, offset) {
      let containerPos = $container.scrollTop
      const dest = Math.ceil($target.offsetTop - containerPos - offset)
      const increment = 20
      let currentTime = 0
      const easeInOutQuad = function (t, x, y, z) {
        t /= z / 2
        if (t <= 1) {
          return Math.ceil(y / 2 * t * t + x)
        } else {
          t--
          return Math.ceil(-y / 2 * (t * (t - 2) - 1) + x)
        }
      }
      const animateScroll = function () {
        currentTime += increment
        $container.scrollTop = easeInOutQuad(currentTime, containerPos, dest, duration)
        if (currentTime <= duration) {
          setTimeout(animateScroll, increment)
        }
      }

      if (!$container || !$target || $target.offsetTop < offset) return false
      animateScroll()
    }
  },
  mounted () {
    this.getCurrentPageOffset(this.items.length)
    this.getPaginationItems()

    this.$nextTick(() => {
      this.scrollToActiveItem(this.items)
    })
  },
  watch: {
    items (newVal, oldVal) {
      this.getCurrentPageOffset(newVal.length)
      this.getPaginationItems()

      this.$nextTick(() => {
        this.scrollToActiveItem(newVal)
      })
    },
    '$route.query.strona' (newVal, oldVal) {
      this.getCurrentPageOffset(this.items.length)
      if (parseInt(newVal) <= Math.ceil(this.items.length / this.maxInit)) {
        this.getPaginationItems()
      } else {
        this.$router.push({
          'name': 'search',
          'query': {
            'kategoria': this.activeCategoryName
          }
        })
      }
    } // END '$route.query.strona' (newVal, oldVal)
  }
}
</script>

<style scoped lang="scss">
.results-wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  margin: $gap-lg 0;
  width: 100%;

  @include screen('sm'){
    justify-content: space-between;
  }

} // END .results-wrapper;

.search-results-footer {
  padding: $gap-md 0;
  position: relative;

  .button-scroll-top {
    bottom: $font-m;
  }

  @include screen('sm'){
    padding: $gap-md 0 $gap-xl;
    text-align: center;

    .button-scroll-top {
      bottom: ($font-m + $gap-md);
    }
  }

}  // END .search-results-footer;
</style>
